@if (isSelectedAxis) {
  <div class="edit-menu-form">
    <div class="form-group">
      <label translate>Name</label>
      <input (change)="onAxisLabelChange()"
        [(ngModel)]="axisSettings.axisYLabel"
           [ngClass]="{
                      'is-invalid': isAxisNameNotSet,
                       'is-valid':!isAxisNameNotSet
                       }"
        [placeholder]="'Enter axis label ...'|translate" class="form-control"
        type="text">
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <div class="form-group mb-0">
            <span class="form-label" translate>Alignment</span>
            <div class="btn-group d-flex btn-group-toggle" name="radioBasic"
              ngbRadioGroup>
              <label [class.active]="isLeftAlignedAxis" class="btn btn-outline-primary w-50"
                ngbButtonLabel>
                <input (click)="selectLeftAlignment()" ngbButton
                  type="radio">
                  <span class="fa-solid fa-align-left mr-2"></span>
                  <span translate>Left</span>
                </label>
                <label [class.active]="!isLeftAlignedAxis" class="btn btn-outline-primary w-50"
                  ngbButtonLabel>
                  <input (click)="selectRightAlignment()" ngbButton
                    type="radio">
                    <span class="fa-solid fa-align-right mr-2"></span>
                    <span translate>Right</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-6">
              <scitis-widget-axis-range-settings
                (rangeChanged)="onAxisRangeChanged($event)"
                [maxY]="axisSettings.maxY"
                [minY]="axisSettings.minY">
              </scitis-widget-axis-range-settings>
            </div>
          </div>
          <scitis-widget-configuration-signals-selector
            (signalSelectionChanged)="onSignalSelected($event)"
            [items]="usableSignals"
            [multiSelection]="true"
            [selectedSignalsIds]="selectedSignalIds"
            [disabledItems]="usedSignalIds"
            [showColor]="true"
            [validate]="false">
          </scitis-widget-configuration-signals-selector>
          <span class="form-label" translate>Selected signals</span>
          @if (!axisSettings.signals || axisSettings.signals.length===0) {
            <div
              class="alert alert-info text-center">
              <span translate>Currently no signals have been added, please add one from above.</span>
            </div>
          }
          <ul class="list-group">
            @for (signal of sortByLabel(axisSettings.signals); track signal) {
              <li class="list-group-item">
                <scitis-line-widget-axis-signal-item
                  (signalRemoveFromAxis)="onRemoveSignalFromAxis(signal)"
                  (signalColorChanged)="onSignalColorChanged($event, signal)"
                  [signalOriginalColor]="getSignalOriginalColor(signal)"
                  [signalHasBeenDeleted]="hasSignalBeenDeleted(signal)"
                  [signal]="signal">
                </scitis-line-widget-axis-signal-item>
              </li>
            }
          </ul>
          @if (hasDeletedSignalsMap.get(axisSettings.id) ?? false) {
            <div class="d-flex align-items-center justify-content-center mb-0 mt-2 alert alert-warning text-center">
              <em class="fa-solid fa-circle-exclamation mr-2"></em>
              <span translate>Signals that have been deleted in the asset configuration have to be removed from the axis.</span>
            </div>
          }
        </div>
      }
